/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_ACTION_COMPLETED_OVER_TIME = gql`
  query GetActionsCompletedOverTime(
    $filters: ActionsInput!
    $groupBy: GroupByDate!
  ) {
    actionsCompletedOverTime(filters: $filters, groupBy: $groupBy) {
      date
      numerator
      denominator
    }
  }
`
